import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, map, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IDictionary, IDictionaryResponse } from '../../models/dictionary.interface';

@Injectable({
  providedIn: 'root',
})
export class DictionaryService {
  private http = inject(HttpClient);

  private currentDictionarySubject = new BehaviorSubject<IDictionary | undefined>(undefined);
  public currentDictionary$ = this.currentDictionarySubject.asObservable();

  getDictionary(): Observable<IDictionary> {
    return this.http.get<IDictionaryResponse>(`${environment.apiUrl}/dictionaries`).pipe(
      map(response => response.data),
      tap(dictionaries => this.currentDictionarySubject.next(dictionaries)),
    );
  }
}
